module.exports = "<div class=\"flexChild container\" *ngIf=\"!objectsArray\">\n  <h2>Your cart appears to be empty.</h2>\n  <button class=\"btn btn-outline-primary\" routerLink=\"/products/all\">Shop Now!</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/cart/empty-cart/empty-cart.component.html
// module id = 402
// module chunks = 1